import {createContext, useContext, useEffect, useState} from 'react';
import UserService from "../services/UserService";
import AccountsService from "../services/AccountsService";
import {useLoading} from "./LoadingContext";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [loggedIn, setLoggedIn] = useState();
    const [authorizing, setAuthorizing] = useState(false);
    const [checkLoggedIn, setCheckLoggedIn] = useState(true);

    const [authData, setAuthData] = useState({email: null, productId: null})
    const { addLoading, removeLoading, isLoading } = useLoading();
    const login = (redirect_uri) => {
        UserService.doLogin(redirect_uri)
    };

    const loginPlatform = (redirect_uri) => {
        UserService.doLoginPlatform(redirect_uri);
    };

    const registerPlatform = (redirect_uri) => {
        UserService.doRegister(redirect_uri)
    };

    useEffect(() => {
        //init keycloak
        addLoading("AUTH")
        UserService.initKeycloak(
            setLoggedIn,
            setAuthorizing
        )
            .then((authenticated) => {
                UserService.setAuthorizing(false, setAuthorizing);
                if (authenticated) {
                    authUpdateUser();
                } else {
                    if(UserService.isSubscriptionAction()){//case insufficient register
                        setLoggedIn(true);
                        if(window.location.pathname !== "/PickProgram" && window.location.pathname !== "/") {//incase if user has pending subscription action, can only access pickprogram
                            window.location.replace("/PickProgram");
                        }
                    }else{
                        setLoggedIn(false);
                    }
                    UserService.clearUserTokens();
                }
            })
            .catch(function (d) {
                UserService.setAuthorizing(false, setAuthorizing);
                UserService.clearUserTokens();
                setLoggedIn(false);
            })
            .finally(()=>{
                addLoading("INIT")
                removeLoading("AUTH")
            })
        // eslint-disable-next-line
    }, []);

    const authUpdateUser = async (force) => {
        if(!isLoading("AUTH")){
            addLoading("AUTH")
        }

        return UserService.updateUserTokens(force)
            .then(unused => {
                return UserService.getUser()
                    .then(userInfo => {
                        return {
                            email: userInfo.email,
                            acceptedMarketing: userInfo.acceptedMarketing,
                            emailVerified: userInfo.email_verified,
                            firstName: userInfo.given_name,
                            lastName: userInfo.family_name,
                            gender: userInfo.gender,
                            dateOfBirth: userInfo.dateOfBirth,
                            phoneNumber: userInfo.phoneNumber,
                            avatar: userInfo.avatar,
                        }
                    })
            })
            .then(mappedUserInfo => {
                return AccountsService.getAccounts()
                    .then(accountUserInfo =>{
                        return {
                            email: accountUserInfo.data.email,
                            avatar: mappedUserInfo.avatar,
                            productName: accountUserInfo.data.subscription?.product?.name,
                            productId: accountUserInfo.data.subscription?.product?.id,
                            subscriptionId: accountUserInfo.data.subscription?.id,
                            prodAttribute: accountUserInfo.data.subscription?.productAttribute,
                            subscriptionState: accountUserInfo.data.subscription?.state,
                            promotionId: accountUserInfo.data?.couponsInformation?.[0]?.id,
                            promotionName: accountUserInfo.data?.couponsInformation?.[0]?.name,
                            pricePointHandle: accountUserInfo.data.subscription?.product.product_price_point_handle,
                            pricePoint: accountUserInfo.data.subscription?.product.product_price_point_handle,
                            pricePointId: accountUserInfo.data.subscription?.product_price_point_id,
                            price: accountUserInfo.data.subscription?.product?.price_with_tax,
                            priceWithTax: accountUserInfo.data.subscription?.product?.price_with_tax,
                            nextProductPricepoint: accountUserInfo.data.subscription?.next_product_handle
                        }
                    })
                    .catch(e =>{
                        console.error(e);
                        if((e.response.status >= 500 && e.response.status < 600) || (e.response.status === 400 && e.response.data.code === 101)) {
                            return {
                                ...mappedUserInfo, ...{error: 303}
                            }
                        }
                    })
            })
            .then(userInfo =>{
                setAuthData(userInfo)
                setLoggedIn(true)
                return userInfo;
            })
            .catch(e => {
                setLoggedIn(false);
            })
            .finally(()=>{
                addLoading("INIT")
                removeLoading("AUTH")
            })
    }

    return (
        <AuthContext.Provider value={{
            loggedIn,
            setLoggedIn,
            authorizing,
            setAuthorizing,
            checkLoggedIn,
            setCheckLoggedIn,
            authData,
            authUpdateUser,
            login,
            loginPlatform,
            registerPlatform
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext);